<template>
  <svg
    class="size"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44.38 32.09"
  >
    <path
      class="cls-1"
      d="M44.19,15.33c-2.61-4.38-5.62-7.88-8.9-10.4l2.54-2.54c.55-.55.55-1.43,0-1.98-.55-.55-1.43-.55-1.98,0l-2.91,2.91C29.56,1.25,25.93.17,22.19.17,13.82.17,6.01,5.55.2,15.33c-.26.44-.26.99,0,1.43,2.61,4.38,5.62,7.88,8.9,10.4l-2.54,2.54c-.55.55-.55,1.43,0,1.98.27.27.63.41.99.41s.72-.14.99-.41l2.91-2.91c3.39,2.06,7.02,3.15,10.75,3.15,8.37,0,16.18-5.39,21.99-15.16.26-.44.26-.99,0-1.43ZM3.03,16.05C8.27,7.6,15.05,2.97,22.19,2.97c3,0,5.93.83,8.71,2.4l-3.82,3.82c-1.38-.99-3.06-1.57-4.88-1.57-4.65,0-8.43,3.78-8.43,8.43,0,1.82.59,3.5,1.57,4.88l-4.24,4.24c-2.93-2.19-5.66-5.25-8.06-9.12ZM27.83,16.05c0,3.11-2.53,5.64-5.64,5.64-1.05,0-2.03-.29-2.87-.79l7.71-7.71c.5.84.79,1.82.79,2.87ZM16.56,16.05c0-3.11,2.53-5.64,5.64-5.64,1.05,0,2.03.29,2.87.79l-7.71,7.71c-.5-.84-.79-1.82-.79-2.87ZM22.19,29.13c-3,0-5.93-.83-8.71-2.4l3.82-3.82c1.38.99,3.06,1.57,4.88,1.57,4.65,0,8.43-3.78,8.43-8.43,0-1.82-.59-3.5-1.57-4.88l4.24-4.24c2.93,2.19,5.66,5.25,8.06,9.12-5.24,8.44-12.02,13.08-19.16,13.08Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
  }
})
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg{
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
